import React, { useState } from 'react';

/*
  <img> con placeholder automático para la landing de Piso SPC.
  - Si la imagen no existe (error 404 / no carga), muestra un bloque con el nombre del archivo
    esperado y su tamaño, respetando la proporción para que el layout se vea igual que con la foto.
  - Para forzar los placeholders aunque las imágenes ya existan, crea un .env.development con:
      REACT_APP_SPC_PLACEHOLDERS=true
    y reinicia `npm start`. Quita la variable (o ponla en false) y se verán las imágenes reales.
  - En producción no hace falta cambiar nada: con las imágenes subidas se comporta como un <img> normal.
*/
const FORZAR_PLACEHOLDER = process.env.REACT_APP_SPC_PLACEHOLDERS === 'true';

const ImagenSpc = ({ src, alt, width, height, ...rest }) => {
  const [fallo, setFallo] = useState(false);

  if (FORZAR_PLACEHOLDER || fallo) {
    const archivo = src.includes('pisos-spc-premium/')
      ? src.split('pisos-spc-premium/')[1]
      : src.split('/').pop();

    return (
      <div
        className="spc-ph"
        role="img"
        aria-label={alt}
        style={width && height ? { '--ph-ratio': `${width} / ${height}` } : undefined}
      >
        <i className="fa-regular fa-image" aria-hidden="true"></i>
        <span className="spc-ph__name">{archivo}</span>
        {width && height && <small className="spc-ph__size">{width} × {height} px</small>}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      onError={() => setFallo(true)}
      {...rest}
    />
  );
};

export default ImagenSpc;